import { observer } from 'mobx-react';

import { useStores } from '../../../stores/useStores';

import { HAMMERS_INTRO_IMAGES } from './constants';

export const MetagamesAssetsPreloader = observer(() => {
  const { hammersStore } = useStores();

  const { hammersEvent } = hammersStore;

  if (!hammersEvent) {
    return null;
  }

  return (
    <div style={{ display: 'none' }}>
      {HAMMERS_INTRO_IMAGES.map((src, index) => (
        <img key={index} alt="Preload" src={src} />
      ))}
    </div>
  );
});
